import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "..";

const requestBaseQuery = baseQuery("categories", "*");

export const categoriesApi = createApi({
  reducerPath: "category",
  baseQuery: requestBaseQuery,
  tagTypes: ["categories"],
  endpoints: (builder) => ({
    getAllCategories: builder.query({
      query: () => ({
        type: "GET",
        order: [
          { column: "created_at", ascending: true },
        ],
      }),
      providesTags: [{ type: "categories", id: "LIST" }],
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetAllCategoriesQuery } = categoriesApi;
